<template>
  <div ref="loaddingPane" class="modal fade" role="dialog" style="">
    <div class="modal-dialog" style="width:100%;">
      <!-- Modal content-->
      <div class="modal-content  panel-warning" style="background-color: rgba(0,0,0,.0001) !important;-webkit-box-shadow: 0 5px 15px rgba(0,0,0,0);
    -moz-box-shadow: 0 5px 15px rgba(0,0,0,0);
    -o-box-shadow: 0 5px 15px rgba(0,0,0,0);
    box-shadow: 0 5px 15px rgba(0,0,0,0);border:0px">
        <div class="modal-body text-center">
          <!--<div class="lds-facebook"><div></div><div></div><div></div></div>-->
          <h3 style="color:white">{{status_text || 'Please wait...'}}</h3>
          <div style="height:200px;">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery';
  import Vue, { onMounted, ref } from 'vue';

  require('../../../node_modules/bootstrap/dist/js/bootstrap.js');

  export default {
    setup(props, context) {
      let loader = {};

      const loaddingPane = ref(null)
      const status_text = ref('')

      let process = false;
      let resover = null;
      let status = 'hide'

      const show = function () {
        if (process || status === 'show') { return }
        process = true;
        return new Promise((rs) => {
          loader.modal({
            backdrop: 'static',
            keyboard: true,
            show: true
          });
          resover = rs;
        })
      }

      const hide = function () {
        if (process || status === 'hide') { return }
        process = true;
        return new Promise((rs) => {
          loader.modal("hide");
          resover = rs;
        })
      };

      const setText = (t) => {
        status_text.value = t || '';
      }

      onMounted(() => {
        loader = $(loaddingPane.value);

        loader.on("hidden.bs.modal", () => {
          resover();
          process = false;
          status = 'hide'
        });

        loader.on("shown.bs.modal", () => {
          resover();
          process = false;
          status = 'show'
        });
      })

      return {
        hide,
        loaddingPane,
        setText,
        show,
        status_text,
      }
    }
  };
</script>
<style scoped>
  .lds-facebook {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

    .lds-facebook div {
      display: inline-block;
      position: absolute;
      left: 8px;
      width: 16px;
      background: #fff;
      animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }

      .lds-facebook div:nth-child(1) {
        left: 8px;
        animation-delay: -0.24s;
      }

      .lds-facebook div:nth-child(2) {
        left: 32px;
        animation-delay: -0.12s;
      }

      .lds-facebook div:nth-child(3) {
        left: 56px;
        animation-delay: 0;
      }

  @keyframes lds-facebook {
    0% {
      top: 8px;
      height: 64px;
    }

    50%, 100% {
      top: 24px;
      height: 32px;
    }
  }
</style>
